import React, { FC } from 'react';
import { useConfig } from '../../../../../context';
import { FareGroupV2, FareGroupProps } from '@entities/fare';

type Props = Omit<FareGroupProps, 'variant' | 'showUpgradeOptions'>;

/**
 * Компонент обертка, достает из конфига настройки для FareGroupV2
 */
const FareGroup: FC<Props> = props => {
	const {
		global: { fareGroupVariant, showFareGroupUpgradeOptions }
	} = useConfig();

	return <FareGroupV2 variant={fareGroupVariant} showUpgradeOptions={showFareGroupUpgradeOptions} {...props} />;
};

export default FareGroup;
